import * as React from 'react';
import { cn } from '@/lib/utils';
import { FiChevronDown } from 'react-icons/fi';

/**
 * SelectNative — wrapped native <select> with consistent border/focus styling
 * matching the project's Input component. Optional left icon support.
 *
 * Children should be <option> elements.
 */
const SelectNative = React.forwardRef(({ className, icon: Icon, children, disabled, ...props }, ref) => {
  const hasNoValue = !props.value || props.value === '' || props.value === 'blank';

  return (
    <div className={cn('relative inline-flex w-full', disabled && 'opacity-50')}>
      {Icon && (
        <span className="pointer-events-none absolute inset-y-0 start-0 flex items-center justify-center ps-3 text-neutral [&_svg]:size-4">
          <Icon aria-hidden="true" />
        </span>
      )}
      <select
        ref={ref}
        disabled={disabled}
        className={cn(
          'c-select-native',
          'ransition-colors flex h-10 w-full appearance-none items-center rounded-md border border-input bg-white px-3 pr-9 text-sm',
          'focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-1',
          'disabled:cursor-not-allowed',
          'aria-invalid:border-danger aria-invalid:focus:ring-danger',
          hasNoValue ? 'text-neutral' : 'text-primary-dark',
          Icon && 'ps-9',
          className
        )}
        {...props}
      >
        {children}
      </select>
      <span className="pointer-events-none absolute inset-y-0 end-0 flex items-center justify-center pe-3 text-neutral [&_svg]:size-4">
        <FiChevronDown aria-hidden="true" />
      </span>
    </div>
  );
});
SelectNative.displayName = 'SelectNative';

export { SelectNative };
